module.exports = __webpack_public_path__ + "img/logo.e3c6b8cf.svg";